import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import FAQSchema from "@/components/seo/FAQSchema";

const FAQSection = () => {
  const faqData = [
    {
      question: "What is an autonomous cyber defence platform and how does an AI-native cyber defence system work?",
      answer: "An autonomous cyber defence platform is a security solution that continuously monitors, detects, and responds to threats without human intervention. As an AI-native cyber defence system, it is built entirely on artificial intelligence, enabling autonomous analysis, adaptive decision-making, and instant protection. This architecture ensures real-time visibility, continuous learning, and faster mitigation than traditional tools."
    },
    {
      question: "How does an autonomous cybersecurity platform use agentic AI cybersecurity and multi-agent AI to protect my organisation?",
      answer: "An autonomous cybersecurity platform uses agentic AI cybersecurity, where multiple intelligent agents independently think, learn, and act. As a multi-agent AI security platform, each AI agent focuses on specific tasks such as threat detection, behavioural analysis, and automated response. These agents work together to deliver deeper insights, faster attack containment, and consistent security across endpoints, cloud, identity, network, and email."
    },
    {
      question: "What are the benefits of AI-driven threat detection and AI-powered incident response?",
      answer: "AI-driven threat detection identifies anomalies, advanced attacks, and behavioural deviations that traditional tools fail to spot. Combined with AI-powered incident response, the system can automatically triage alerts, correlate signals, and contain threats instantly. This dramatically reduces risk, lowers false positives, and accelerates mitigation during high-speed attacks like ransomware or identity-based intrusions."
    },
    {
      question: "How does an autonomous XDR platform support AI-based SOC automation, real-time cyber defence, and zero-touch cyber defence?",
      answer: "An autonomous XDR platform unifies signals from all security layers and uses AI to correlate and respond across your environment. Through AI-based SOC automation, workflows such as triage, investigation, and remediation run automatically, reducing SOC fatigue. As a real-time cyber defence platform, it responds instantly to active threats, and its zero-touch cyber defence capabilities allow full autonomous response without manual approval—critical for time-sensitive attacks."
    },
    {
      question: "What are self-healing cybersecurity, autonomous security operations, and an AI-first cybersecurity platform?",
      answer: "Self-healing cybersecurity enables the system to automatically restore compromised endpoints, user sessions, or configurations back to a safe state. Autonomous security operations use AI to run detection, investigation, response, and recovery without human involvement. As an AI-first cybersecurity platform, the entire security lifecycle is driven by advanced machine reasoning, delivering faster, more accurate, and more resilient cyber defence for modern enterprises."
    }
  ];

  return (
    <section className="py-16 md:py-20 bg-background" id="faq">
      <FAQSchema faqs={faqData} title="Autonomous Cyber Defence Platform - Frequently Asked Questions" />
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Frequently Asked <span className="text-[#8932c8]">Questions</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Everything you need to know about Spharaka's autonomous cyber defence platform
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqData.map((faq, index) => (
              <AccordionItem 
                key={`item-${index + 1}`} 
                value={`item-${index + 1}`} 
                className="border rounded-lg border-border px-6 bg-card"
              >
                <AccordionTrigger className="text-lg font-semibold py-5 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
